import { renderMainMenuActions } from "client/Features/Layout/MainMenuActions/MainMenuActions";
import { ensureNotNil } from "client/Misc/utils";

function init() {
	renderMainMenuActions(
		ensureNotNil(
			document.getElementById("main-menu-actions-host")
		)
	);
}

export {
	init
};
